var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParagraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H3V13H10V12Z",
    fill: "#6D747D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9H3V10H13V9Z",
    fill: "#6D747D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6H3V7H13V6Z",
    fill: "#6D747D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3H3V4H13V3Z",
    fill: "#6D747D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraph);
export default __webpack_public_path__ + "static/media/Paragraph.582ec09cf260cd360e88dae2920aac1f.svg";
export { ForwardRef as ReactComponent };